// extracted by mini-css-extract-plugin
export var item = "statistics-item-module--item--KIVPi";
export var amount = "statistics-item-module--amount--b9Gix";
export var description = "statistics-item-module--description--A05MB";